var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShooting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.4,
    cy: 15.4,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9,132.4c-0.7,2.8,0.9,5.6,3.6,6.3s5.6-0.9,6.3-3.6L44,74.6H33.4L17.9,132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6,74.6H46L62.2,135c0.7,2.8,3.6,4.4,6.3,3.6s4.4-3.6,3.6-6.3L56.6,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.1,28.3H18c-2.8,0-5.1,2.3-5.1,5.1s2.3,5.1,5.1,5.1h15.4v30.9h23.1V45.8l5.8,5.8c2,2,5.3,2,7.3,0L90.2,31h22.9V28.3z  M66,40.7L56.3,31h19.4L66,40.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShooting);
export default __webpack_public_path__ + "static/media/shooting.33da1f1cf9b6853d339a2eada24a3782.svg";
export { ForwardRef as ReactComponent };